import { enqueueSnackbar } from 'notistack';

import { dispatch, store } from 'store';
import { incrementMessagesQuotaUsed } from 'store/slices/accountModules';
import {
  canConsumeMessagesQuota,
  type MessagesQuota,
} from 'types/account/messagesQuota';

const QUOTA_SNACKBAR = {
  exceeded: 'הגעתם למכסת ההודעות. לא ניתן לשלוח הודעות נוספות.',
  insufficient: (remaining: number, requested: number) =>
    `נותרו ${remaining} הודעות במכסה — לא ניתן לשלוח ${requested} הודעות.`,
} as const;

export function getMessagesQuotaFromStore(): MessagesQuota | null {
  return store.getState().accountModules.data?.messagesQuota ?? null;
}

function notifyQuotaBlocked(quota: MessagesQuota, count: number): void {
  const message =
    quota.remaining <= 0
      ? QUOTA_SNACKBAR.exceeded
      : QUOTA_SNACKBAR.insufficient(quota.remaining, count);

  enqueueSnackbar(message, { variant: 'error' });
}

/** Returns false when send must be blocked. Otherwise consumes quota optimistically. */
export function consumeMessagesQuota(count = 1): boolean {
  const safeCount = Math.max(1, Math.floor(count));
  const quota = getMessagesQuotaFromStore();

  if (!quota) return true;

  if (!canConsumeMessagesQuota(quota, safeCount)) {
    notifyQuotaBlocked(quota, safeCount);
    return false;
  }

  dispatch(incrementMessagesQuotaUsed(safeCount));
  return true;
}
